export default "__VITE_ASSET__DvRnyCsL__"